import React from 'react';
import { Section } from './ui/Section';
import { ArrowRight } from 'lucide-react';
export function PackElite() {
  return <Section className="bg-brand-ice/50" data-id="element-146">
      <div className="text-center mb-8 md:mb-16" data-id="element-147">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-2 md:mb-4 text-brand-dark" data-id="element-148">
          ¿QUÉ AGREGA EL PACK ÉLITE™?
        </h2>
        <p className="text-base md:text-xl text-brand-dark/70 max-w-2xl mx-auto" data-id="element-149">
          El sistema para profesores que no solo quieren enseñar — quieren
          crecer
        </p>
        <div className="w-16 md:w-24 h-1 bg-brand-accent mx-auto rounded-full mt-4 md:mt-6" data-id="element-150"></div>
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12" data-id="element-151">
        {/* Module 1 */}
        <div className="bg-brand-ice/60 rounded-xl md:rounded-2xl p-5 md:p-8 border border-brand-iceDark shadow-sm relative overflow-hidden" data-id="element-152">
          <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 bg-brand-accent/10 rounded-bl-full -z-0" data-id="element-153"></div>

          <div className="relative z-10" data-id="element-154">
            <div className="text-3xl md:text-4xl mb-2 md:mb-4" data-id="element-155">🏆</div>
            <h3 className="text-lg md:text-2xl font-bold text-brand-dark mb-1 md:mb-2" data-id="element-156">
              MÓDULO ÉLITE 1 — COMPETENCIA Y ALTO RENDIMIENTO
            </h3>
            <p className="text-sm md:text-base text-brand-dark/70 italic mb-4 md:mb-8 border-l-4 border-brand-accent pl-3 md:pl-4" data-id="element-157">
              "Preparación completa para llevar a tus alumnos a competir con
              criterio, seguridad y resultados"
            </p>

            <div className="space-y-3 md:space-y-6" data-id="element-158">
              <div data-id="element-159">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-160">
                  No sabés cómo preparar a un alumno para competir
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-161">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-162" />
                  Guía completa de preparación pre-competencia
                </p>
              </div>
              <div data-id="element-163">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-164">
                  Tus alumnos se ponen nerviosos y bajan el rendimiento
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-165">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-166" />
                  Protocolo de gestión emocional y rutina pre-competencia
                </p>
              </div>
              <div data-id="element-167">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-168">
                  No conocés bien el reglamento de competencia
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-169">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-170" />
                  Reglamento FAP y World Skate simplificado y explicado
                </p>
              </div>
              <div data-id="element-171">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-172">
                  No sabés cómo analizar el desempeño después de competir
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-173">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-174" />
                  Hoja de análisis post-competencia lista para usar
                </p>
              </div>
              <div data-id="element-175">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-176">
                  No tenés un plan de entrenamiento para la temporada
                  competitiva
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-177">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-178" />
                  Ciclo anual competitivo completo con periodización
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Module 2 */}
        <div className="bg-brand-ice/60 rounded-xl md:rounded-2xl p-5 md:p-8 border border-brand-iceDark shadow-sm relative overflow-hidden" data-id="element-179">
          <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 bg-brand-accent/10 rounded-bl-full -z-0" data-id="element-180"></div>

          <div className="relative z-10" data-id="element-181">
            <div className="text-3xl md:text-4xl mb-2 md:mb-4" data-id="element-182">🏫</div>
            <h3 className="text-lg md:text-2xl font-bold text-brand-dark mb-1 md:mb-2" data-id="element-183">
              MÓDULO ÉLITE 2 — GESTIÓN Y MARKETING PARA TU ACADEMIA
            </h3>
            <p className="text-sm md:text-base text-brand-dark/70 italic mb-4 md:mb-8 border-l-4 border-brand-accent pl-3 md:pl-4" data-id="element-184">
              "Abrí, organizá y hacé crecer tu espacio de patinaje artístico de
              forma profesional y rentable"
            </p>

            <div className="space-y-3 md:space-y-6" data-id="element-185">
              <div data-id="element-186">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-187">
                  No sabés cómo montar tu propia academia desde cero
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-188">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-189" />
                  Guía paso a paso para crear tu espacio propio
                </p>
              </div>
              <div data-id="element-190">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-191">
                  Cobrás lo mismo de siempre sin poder justificar una suba
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-192">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-193" />
                  Estructura de precios, tarifas y modalidades de cobro
                </p>
              </div>
              <div data-id="element-194">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-195">
                  No tenés presencia profesional en redes sociales
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-196">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-197" />
                  Marketing en Instagram para academias de patinaje artístico
                </p>
              </div>
              <div data-id="element-198">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-199">
                  No contás con documentación profesional
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-200">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-201" />
                  Contratos, reglamentos y formularios listos para usar
                </p>
              </div>
              <div data-id="element-202">
                <p className="text-brand-dark/50 text-xs md:text-sm mb-0.5 md:mb-1 line-through" data-id="element-203">
                  No sabés cómo atraer y retener alumnos nuevos
                </p>
                <p className="text-sm md:text-base text-brand-dark font-semibold flex items-start" data-id="element-204">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-1.5 md:mr-2 flex-shrink-0 mt-0.5" data-id="element-205" />
                  Estrategia de captación y fidelización de familias
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}